import React from 'react';
import PropTypes from 'prop-types';

import ThemeContext, { themes } from '../../config/themeContext';
import TemplateManager from './templateManager';

export default function StyleTemplate(props) {
  return (
    <>
      <ThemeContext.Provider value={themes[props.config.theme]}>
        <TemplateManager {...props} />
      </ThemeContext.Provider>
    </>
  );
}

StyleTemplate.propTypes = {
  config: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
  playlistmodel: PropTypes.object.isRequired,
};
